import { initDB } from 'react-indexed-db'

export const DBConfig = {
    name: 'ProgrammingPage',
    version: 3,
    objectStoresMeta: [
        {
            store: 'ProgramData',
            storeConfig: { keyPath: 'id', autoIncrement: false },
            storeSchema: [
                {
                    imageURL: 'imageURL',
                    keypath: 'imageURL',
                    options: { unique: false },
                },
            ],
        },
        {
            store: 'SavedFaces',
            storeConfig: { keyPath: 'id' },
            storeSchema: [
                {
                    imageURL: 'imageURL',
                    imageTensors: 'imageTensors',
                    keypath: 'imageURL',
                    className: 'className',
                    options: { unique: false },
                },
            ],
        },
        {
            store: 'AudioFiles',
            storeConfig: { keyPath: 'id', autoIncrement: true },
            storeSchema: [
                {
                    name: 'fileName',
                    keypath: 'fileName',
                    options: { unique: false },
                },
                {
                    name: 'fileData',
                    keypath: 'fileData',
                    options: { unique: false },
                },
            ],
        },
        {
            store: 'models',
            storeConfig: { keyPath: 'id', autoIncrement: false },
            storeSchema: [
                {
                    name: 'modelName',
                    keypath: 'modelName',
                    options: { unique: false },
                },
                {
                    name: 'isGenerateTensor',
                    keypath: 'isGenerateTensor',
                    options: { unique: false },
                },
                {
                    name: 'ImageClass',
                    keypath: 'ImageClass',
                    options: { unique: false },
                },
                {
                    name: 'epochs',
                    keypath: 'epochs',
                    options: { unique: false },
                },
                {
                    name: 'batchSize',
                    keypath: 'batchSize',
                    options: { unique: false },
                },
            ],
        },
    ],
}

// const audioDbConfig = {
//     name: 'AudioDB',
//     version: 1,
//     objectStoresMeta: [
//         {
//             store: 'audioFiles',
//             storeConfig: { keyPath: 'id', autoIncrement: true },
//             storeSchema: [
//                 {
//                     name: 'fileName',
//                     keypath: 'fileName',
//                     options: { unique: false },
//                 },
//                 {
//                     name: 'fileData',
//                     keypath: 'fileData',
//                     options: { unique: false },
//                 },
//             ],
//         },
//     ],
// }

// initDB(DBConfig)
